// ✅ src/pages/ExpoSuccess.js
import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CelebrationIcon from "@mui/icons-material/Celebration";
import confetti from "../assets/confetti.gif";

const ExpoSuccess = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const name = state?.name || "Guest";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #141E30 0%, #243B55 100%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        color: "#fff",
        p: 2,
      }}
    >
      {/* <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 120 }}
      >
        <CheckCircleIcon
          sx={{
            fontSize: 90,
            color: "#FFC857",
            mb: 2,
            filter: "drop-shadow(0 0 10px #ffc857aa)",
          }}
        />
      </motion.div> */}
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <motion.img
          src={confetti}
          alt="Confetti Animation"
          style={{
            position: "absolute",
            top: "-40%",
            left: "-40%",
            width: "180%",
            height: "180%",
            objectFit: "cover",
            zIndex: 0,
            opacity: 0.6,
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.6 }}
          transition={{ duration: 1 }}
        />
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 120 }}
          style={{ zIndex: 1 }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: 90,
              color: "#FFC857",
              mb: 2,
              filter: "drop-shadow(0 0 10px #ffc857aa)",
            }}
          />
        </motion.div>
      </Box>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.8 }}
      >
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, mb: 1, color: "#FFC857" }}
        >
          Thank You, {name}! 🎉
        </Typography>
        <Typography sx={{ fontSize: 17, color: "#ddd", mb: 3, maxWidth: 500 }}>
          Your spot for the <strong>Dubai Property Expo</strong> has been
          successfully reserved. Our team will contact you shortly with event
          details and confirmation. 🏙️✨
        </Typography>
      </motion.div>

      {/* Submit more inquiry button */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.9, duration: 0.8 }}
      >
        <Button
          variant="contained"
          sx={{
            mt: 1,
            px: 4,
            py: 1.4,
            fontWeight: 600,
            borderRadius: "8px",
            bgcolor: "#FFC857",
            color: "#000",
            textTransform: "none",
            boxShadow: "0 6px 18px rgba(0,0,0,0.35)",
            "&:hover": {
              bgcolor: "#e6b34e",
              boxShadow: "0 8px 22px rgba(0,0,0,0.45)",
            },
          }}
          onClick={() => navigate(-1)}
        >
          Submit for more inquiry
        </Button>
      </motion.div>

      {/* <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.2 }}
      >
        <Button
          variant="contained"
          sx={{
            mt: 2,
            px: 4,
            py: 1.4,
            fontWeight: 600,
            borderRadius: "8px",
            bgcolor: "#FFC857",
            color: "#000",
            "&:hover": { bgcolor: "#e6b34e" },
          }}
          onClick={() => navigate("/")}
        >
          Back to Home
        </Button>
      </motion.div> */}

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
      >
        <Typography sx={{ mt: 3, fontSize: 15, color: "#aaa" }}>
          <CelebrationIcon sx={{ fontSize: 18, verticalAlign: "middle" }} /> See
          you at the Expo!
        </Typography>
      </motion.div>
    </Box>
  );
};

export default ExpoSuccess;
